export function logDeploymentInfo() {
  const allowedDomain = 'https://we-uat-lulalend-support.azurewebsites.net';
  const currentUrl = window.location.href;

  if (!currentUrl.startsWith(allowedDomain)) {
    return;
  }

  console.log(
    '%cWelcome to Applet UAT',
    'font-size: 16px; font-weight: bold; color: #2E8B57;'
  );

  const generalInfo = {
    API_BASEURL: process.env.REACT_APP_API_BASEURL,
    PKCE_CLIENT_ID: process.env.REACT_APP_PKCE_CLIENT_ID,
  };

  console.group('%cGeneral Info', 'font-weight: bold; color: #1E90FF;');
  console.table(generalInfo);
  console.groupEnd();

  const enabledModules = {
    BANK_MODULE: process.env.REACT_APP_BANK_MODULE_ENABLED,
    TRANSACTIONS: process.env.REACT_APP_BANK_MODULE_TRANSACTIONS_ENABLED,
    STATEMENTS: process.env.REACT_APP_BANK_MODULE_STATEMENTS_ENABLED,
    CREDIT_MODULE: process.env.REACT_APP_CREDIT_MODULE_ENABLED,
  };

  console.info('Enabled Modules', enabledModules);

  const buildInfo = {
    FE_COMMIT_HASH: process.env.REACT_APP_FE_COMMIT_HASH,
    FE_BRANCH_NAME: process.env.REACT_APP_FE_BRANCH_NAME,
    FE_BUILD_DATE: process.env.REACT_APP_FE_BUILD_DATE,
  };

  console.info('Build Information', buildInfo);
}
